import React from "react";
import { ContactSection } from "../elements/contact-section";
import { Conferences } from "../elements/hcp-marketing/conferences";
import HCPConferencesSliderSection from "../elements/hcp-marketing/conferences-slider";
import { DetailsSection } from "../elements/details";
import { EmailMarketing } from "../elements/hcp-marketing/email-marketing";
import HCPMarketingBanner from "../elements/hcp-marketing/main-banner";
import { ManagedServices } from "../elements/hcp-marketing/managed-services";
import { TargetAdvantages } from "../elements/hcp-marketing/target-advantages";
import { TargetingStrategy } from "../elements/targetingStrategy";
import { VideoSection } from "../elements/hcp-marketing/video-section";
import { Advantages } from "../elements/hcp-marketing/advantages";
import hcpBannerImg from "../../images/banner/hcp-marketing-banner.jpg";

const hcpTypes = [
  { id: "display", label: "Display" },
  { id: "online video", label: "Online Video" },
  { id: "social", label: "Social " },
  { id: "streaming tv", label: "Streaming TV" },
  { id: "email", label: "Email" },
  { id: "search", label: "Search" },
  { id: "emr/ehr", label: "EMR/EHR" },
];

function HCPMarketing() {
  return (
    <>
      <HCPMarketingBanner
        title="HCP Marketing"
        topic="Digital Marketing & Advertising to Reach Healthcare Professionals"
        description="To help engage HCPs, you now have a powerful and precise way to reach your target audience by utilizing specific clinical codes like NPI numbers, ICD-10, or CPT codes. <br/> We collaborate with clients strategically to define KPIs, drive new HCP acquisitions, expand engagement with current providers, and cross-sell relevant solutions—ultimately increasing HCP adoption rates with measurable results."
        image={hcpBannerImg}
      />
      <Advantages />
      <DetailsSection
        title="Omni-Channel Marketing Approach "
        description="Most marketers looking to improve their results recognize the power of a multi-channel approach.<br/> Digital marketing excels in this area, allowing you to combine multiple tactics to maximize reach and create the frequency needed for real impact."
        secondTitle="Tactics we use:"
        items={hcpTypes}
      />
      <TargetAdvantages />
      <ManagedServices description="If you're new to using data for better HCP digital marketing outcomes — don’t worry. We offer full support throughout each campaign, so you’ll gain clear insights into performance and always know your next steps for success." />
      <TargetingStrategy
        title="Let’s Build Your Targeting Strategy"
        description="Tell us which healthcare professionals (HCPs) you’d like to reach, and we’ll research audience <br/> size and create a tailored marketing plan — no commitment required."
      />
      <VideoSection />
      <Conferences />
      <HCPConferencesSliderSection />
      <EmailMarketing />
      <ContactSection />
    </>
  );
}

export default HCPMarketing;
